import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe } from 'react-icons/fa';
import i18n from '../i18n';

// Per Asnake: language switcher must be reachable from every page --
// landing, login, signup, and the whole logged-in customer dashboard --
// not just buried in account settings.
const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'rw', label: 'Kinyarwanda' },
  { code: 'am', label: 'አማርኛ' },
  { code: 'fr', label: 'Français' },
];

const LanguageSwitcher = ({ dark = false }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = i18n.resolvedLanguage || 'en';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={`p-1.5 bg-transparent ${dark ? 'text-white' : 'text-gray-500'} hover:opacity-80`}
        title={t('language.title', 'Language')}
      >
        <FaGlobe size={18} />
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-2 w-40 rounded-xl bg-white py-2 shadow-xl ring-1 ring-black/5">
          {SUPPORTED_LANGUAGES.map(({ code, label }) => (
            <button
              key={code}
              type="button"
              onClick={() => handleSelect(code)}
              className={`w-full flex items-center justify-between px-4 py-2 text-sm bg-white hover:bg-gray-50 transition-colors ${
                code === current ? 'text-[#1c7d7f] font-medium' : 'text-gray-700'
              }`}
            >
              <span>{label}</span>
              {code === current && <span className="text-xs">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
